import type { CommerceRegistryThemePalette } from '../../../domain/commerce-registry/models/commerce-registry-theme-palette.model';

export const commerceRegistryThemePaletteMock: CommerceRegistryThemePalette = {
  primary: '#df6129',
  secondary: '#e1d5af',
  tertiary: '#a48363',
  textHint: 'rgba(225, 213, 175, 0.4)',
  input: 'transparent',
  typography: 'Nunito',
  backgroundImage: 'https://stash-search-16029613.figma.site/_assets/v11/446990b9f3c3e90d3b1e10c38ccd878c0f281df6.png',
};
